var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ali-oss" },
    [
      _vm.bigImage
        ? [
            _c(
              "el-carousel",
              {
                attrs: {
                  autoplay: false,
                  height: "400px",
                  arrow: "always",
                  "initial-index": _vm.dialog.index
                }
              },
              _vm._l(_vm.previewFiles, function(file) {
                return _c("el-carousel-item", { key: file.uid }, [
                  _c(
                    "div",
                    { staticClass: "oss-carousel-box" },
                    [
                      _vm.isImage(file)
                        ? _c("el-image", {
                            attrs: { src: _vm.previewUrl(file) }
                          })
                        : _c("ybl-pdf", {
                            key: "pdf_" + file.uid,
                            attrs: {
                              src: _vm.previewUrl(file),
                              id: "carouse_item_" + file.uid
                            }
                          })
                    ],
                    1
                  )
                ])
              }),
              1
            )
          ]
        : [
            _vm.listType !== "view"
              ? _c(
                  "el-upload",
                  _vm._g(
                    _vm._b(
                      {
                        attrs: {
                          action: "",
                          "auto-upload": false,
                          "file-list": _vm.files,
                          "on-change": _vm.fileChange,
                          "before-remove": _vm.beforeRemove
                        }
                      },
                      "el-upload",
                      _vm.$attrs,
                      false
                    ),
                    _vm.$listeners
                  ),
                  [_vm._t("default")],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _vm._t("tip"),
            _vm._v(" "),
            _vm.preview
              ? [
                  _c(
                    "ul",
                    {
                      staticClass:
                        "el-upload-list el-upload-list--picture-card ali-oss__preview"
                    },
                    _vm._l(_vm.fileList, function(file, index) {
                      return _c("div", { key: file.uid }, [
                        _c(
                          "li",
                          { staticClass: "el-upload-list__item is-ready" },
                          [
                            _vm.isImage(file)
                              ? _c("img", {
                                  staticClass: "el-upload-list__item-thumbnail",
                                  attrs: { src: _vm.previewUrl(file), alt: "" }
                                })
                              : _vm.isPdf(file)
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "el-upload-list__item-thumbnail ali-oss__ext"
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "image_icon",
                                      attrs: {
                                        src:
                                          "https://openapi.youbaolian.cn/pic/0/14/4fa894538a3e41b3a5a8cd28cbddfceb.jpeg"
                                      }
                                    })
                                  ]
                                )
                              : _c(
                                  "div",
                                  {
                                    staticClass:
                                      "el-upload-list__item-thumbnail ali-oss__ext"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(file.ext || _vm.fileExt(file))
                                    )
                                  ]
                                ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "el-upload-list__item-actions" },
                              [
                                _vm.canPreview(file)
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "el-upload-list__item-preview",
                                        on: {
                                          click: function($event) {
                                            return _vm.handlePreview(
                                              file,
                                              index
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-zoom-in"
                                        })
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.canDownload(file)
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "el-upload-list__item-delete",
                                        on: {
                                          click: function($event) {
                                            return _vm.handleDownload(
                                              file,
                                              index
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-download"
                                        })
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.showDelete
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "el-upload-list__item-delete",
                                        on: {
                                          click: function($event) {
                                            return _vm.handleRemove(file, index)
                                          }
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-delete"
                                        })
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _c("el-progress", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: file.status === "uploading",
                                  expression: "file.status==='uploading'"
                                }
                              ],
                              attrs: {
                                format: _vm.progressFormat,
                                type: "circle",
                                percentage: file.percentage,
                                width: 100
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "ali-oss__text" }, [
                          _vm._v(_vm._s(file.fileName || file.name))
                        ])
                      ])
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c(
                    "ybl-dialog",
                    {
                      attrs: {
                        visible: _vm.dialog.visible,
                        title: "文件预览",
                        showFooter: false,
                        "append-to-body": true
                      },
                      on: { close: _vm.close }
                    },
                    [
                      _c(
                        "el-carousel",
                        {
                          attrs: {
                            autoplay: false,
                            height: "600px",
                            arrow: "always",
                            "initial-index": _vm.dialog.index
                          }
                        },
                        _vm._l(_vm.previewFiles, function(file) {
                          return _c("el-carousel-item", { key: file.uid }, [
                            _c(
                              "div",
                              { staticClass: "oss-carousel-box" },
                              [
                                _vm.isImage(file)
                                  ? _c("el-image", {
                                      attrs: { src: _vm.previewUrl(file) }
                                    })
                                  : _c("ybl-pdf", {
                                      key: "pdf_" + file.uid,
                                      attrs: {
                                        src: _vm.previewUrl(file),
                                        id: "carouse_item_" + file.uid
                                      }
                                    })
                              ],
                              1
                            )
                          ])
                        }),
                        1
                      )
                    ],
                    1
                  )
                ]
              : _vm._e()
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-12a30621", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12a30621","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/aliOSS.vue
// module id = null
// module chunks = 